import React, {useContext, useEffect} from 'react';
import { Button } from 'antd';
import { ModelContext } from '../../metadata/ModelSource';
import { stringToUIString, getAge } from '../../../utils/dateUtils';
import { BuyContext } from '../../Workflow';
import { PremiumAlertMessageContext } from '../../../context/PremiumAlertMessageProvider';
import { formatMoneyAmount } from '../../../utils/formatUtils';

export const SummaryDetails = ({
    lineCd,
  quoteLengthLabel,
  summaryDescription,
  summaryActionLinkText,
  summaryActionText,
  discounts,
  style={},
  useBuyLink,
}) => {
  const { data: model } = useContext(ModelContext);
  const { next, bindAndNavigate, mainAction, state,setState } = useContext(BuyContext);
  const { setPolicyTotalPremiumAmt } = useContext(PremiumAlertMessageContext);
  const { summaryActionTextStyle } = style;

  useEffect(()=>{
    const total =
      parseFloat(model.basicPolicy.writtenPremiumAmt) +
      parseFloat(model.basicPolicy.writtenFeeAmt);
    setPolicyTotalPremiumAmt(total);
  },[])

  const QuoteLength = () => {
    const total =
      parseFloat(model.basicPolicy.writtenPremiumAmt) +
      parseFloat(model.basicPolicy.writtenFeeAmt);

    const startDate = stringToUIString(model.basicPolicy.effectiveDt);
    const endDate = stringToUIString(model.basicPolicy.expirationDt);

    if (
      !model.basicPolicy.writtenPremiumAmt ||
      !model.basicPolicy.writtenFeeAmt ||
      total <= 0
    ) {
      return (
        <h3>
          {quoteLengthLabel} {startDate} - {endDate} is not yet calculated
        </h3>
      );
    }

    return (
      <h3>
        {quoteLengthLabel} {startDate} - {endDate} is{' '}
        <span style={{ fontWeight: 'bold' }}>
          {formatMoneyAmount(total)}/{model.basicPolicy.renewalTermCd}
        </span>
      </h3>
    );
  };

  const CoveredDrivers = () => {
    const drivers = model && model.drivers ? model.drivers.filter(driver => driver.status !== 'Deleted'):null;


    if (!drivers || drivers.length <= 0) {
      return (
        <div>
          <p>No drivers entered</p>
        </div>
      );
    }

    const Drivers = () => {
      return drivers.map((driver, index) => {
        return (
          <div key={index}>
            <p style={styles.margin}>
              <span style={{ fontWeight: 'bold' }}>
                {driver.nameInfo.givenName} {driver.nameInfo.surname}
              </span>{' '}
              {driver.personInfo.birthDt ? (
                <span>({getAge(driver.personInfo.birthDt)} years old)</span>
              ) : (
                <span>(age not entered)</span>
              )}
            </p>
          </div>
        );
      });
    };

    return (
      <div style={styles.containerMargin}>
        <p style={styles.margin}>Covered driver(s):</p>
        <Drivers />
      </div>
    );
  };

  const CoveredVehicles = () => {
    const vehicles = model.lines[0].risks ? model.lines[0].risks.filter(risk => risk.status !== 'Deleted') : null;

    if (!vehicles || vehicles.length <= 0) {
      return (
        <div>
          <p>No vehicles entered</p>
        </div>
      );
    }

    const Vehicles = () => {
      return vehicles.map((risk, index) => {
        const { vehicle } = risk;
        return (
          <div key={index}>
            <p style={styles.margin}>
              <span style={{ fontWeight: 'bold' }}>
                {vehicle.modelYr} {vehicle.manufacturer}
              </span>{' '}
              {vehicle.model}{' '}
              {vehicle.vehIdentificationNumber
                ? `(VIN ${vehicle.vehIdentificationNumber})`
                : '(No VIN identified)'}
            </p>
          </div>
        );
      });
    };

    return (
      <div style={styles.containerMargin}>
        <p style={styles.margin}>Covered vehicle(s):</p>
        <Vehicles />
      </div>
    );
  };

  const DiscountsApplied = () => {
    const drivers = model.drivers;

    const foundDiscounts =  (drivers && drivers.length > 0) ?
      drivers.reduce((allDiscounts, currentDriver) => {
      const driverInfo = currentDriver.driverInfo;

      discounts.map((currentDiscount) => {
        if (driverInfo[currentDiscount.discount] === true) {
          const driverWithDiscount = {
            driverGivenName: currentDriver.nameInfo.givenName,
            discount: currentDiscount.discount,
            label: currentDiscount.label,
          };
          return allDiscounts.push(driverWithDiscount);
        }
      });

      return allDiscounts;
    }, []) : [];

    const Discounts = () => {
      if (foundDiscounts.length <= 0) {
        return (
          <div>
            <p style={styles.margin}>No discounts applied</p>
          </div>
        );
      }
      return foundDiscounts.map((discount, index) => {
        const { driverGivenName, label } = discount;
        return (
          <div key={index}>
            <p style={styles.margin}>
              <span style={{ fontWeight: 'bold' }}>{label}</span> (
              {driverGivenName})
            </p>
          </div>
        );
      });
    };

    return (
      <div style={styles.containerMargin}>
        <p style={styles.margin}>Discount(s) applied:</p>
        <Discounts />
      </div>
    );
  };



  const BuyItControl = () => {
    if (summaryActionLinkText) {
        const buttonAction = mainAction;
        if (useBuyLink) {
            // This is the legacy way of presenting a link to the buy-now experience
            return (
                <h3>
                    <a className="link-to-step" onClick={buttonAction}>
                        {summaryActionLinkText}
                    </a>{' '}
                    {summaryActionText}
                </h3>
            );
        } else {
            // This is the buy-now button presentation
            return (
                <center>
                    <Button
                        style={{ marginLeft: '4px', marginBottom: '20px' }}
                        type="primary"
                        loading={state.loadingNext}
                        onClick={()=> {
                          setState({
                            ...state,
                            loadingNext: true
                          });
                          buttonAction();
                        }}
                    >
                        {summaryActionLinkText}
                    </Button>
                  <ActionDescription text={summaryActionText} style={summaryActionTextStyle}/>
                </center>
            );
        }
    } else {
        return '';
    }
  }

  const HomeownerProperty = () => {
    const building = model.lines[0].risks[0].building;
    const address = building ? building.addresses.filter((addr) => addr.addrTypeCd === 'RiskAddr') : null;

    //if no address has been entered
    if (!address || !address[0].addr1) {
      return (
          <div>
            <p>No property address entered</p>
          </div>
      );
    }

    return(<div>
      <p>For the property located at:</p>
      <p style={ styles.bold}>{`${address[0].addr1} ${address[0].city}, ${address[0].stateProvCd}, ${address[0].postalCode}`}</p>
    </div>)
  };

  const getSummaryDetails = (lineCd) => {
    switch(lineCd){
      case 'PersonalAuto': return (
          <div className={'summary-details'}>
            <QuoteLength />
            <div>
              <p>{summaryDescription}</p>
            </div>
            <CoveredDrivers />
            <CoveredVehicles />
            <DiscountsApplied />
            <div style={styles.containerMargin}>
              <BuyItControl />
            </div>
          </div>
      );
      case 'Homeowners':
        return (
            <div className={'summary-details'}>
              <QuoteLength/>
              <div>
                <HomeownerProperty/>
                <p>{summaryDescription}</p>
              </div>
              <div style={styles.containerMargin}>
                <BuyItControl/>
              </div>
            </div>
        );
    }
  }

  return getSummaryDetails(lineCd);
};

export const ActionDescription = ({style, text})=>{
  style={ color:'rgb(0, 115, 157, 1)', textAlign:'center', ...style }
  return <h3 style={style} >{text}</h3>
}

const styles = {
  margin: {
    marginBottom: '2px',
  },
  containerMargin: {
    marginTop: '20px',
  },
  bold: {
    fontWeight: 'bold',
  }
};
